import React from 'react';
import styles from './PFSVIAA.module.css';
import ContentContainer from '../ContentContainer/ContentContainer';
import VIAALogo from './VIAA_logo.png';
import { NavLink, useLocation } from 'react-router-dom';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { PartnersIndexBreadcrumb } from '../PFSPartnersIndex/PFSPartnersIndex';

const PFSVIAA = () => {
  const { pathname } = useLocation();

  useBreadcrumb([
    PartnersIndexBreadcrumb,
    {
      label: 'Valley Insurance Agency Alliance',
      url: pathname,
    },
  ]);

  return (
    <div className={styles.PfsVIAA} data-testid="PfsVIAA">
      <ContentContainer>
        <img className={styles.logo} src={VIAALogo} alt="VIAA Logo" />
        <h1>Valley Insurance Agency Alliance Joins PFS Global as a Partner!</h1>
        <div className={styles.content}>
          <p>
            We are pleased to announce that Valley Insurance Agency Alliance (VIAA) has
            become a partner of PFS Global. Founded in 2006 and headquartered in St. Louis, MO,
            VIAA is an insurance network of more than 165 independent agencies.
          </p>
          <p>
            Over the last 20 years, VIAA members have surpassed $1B in written premium,
            reflecting the collective strength of the alliance. VIAA is a family-owned
            organization with a mission to <strong>accelerate the growth</strong> of
            independent agency owners through proven industry best practices that increase
            retention and profit.
          </p>
          <p>
            This collaboration allows us to integrate VIAA's network and expertise into
            our offerings, ensuring that we deliver enhanced value and efficiency to you,
            our esteemed clients.
          </p>
          <p>
            For more information about Valley Insurance Agency Alliance, please visit{' '}
            <a href="https://viaa4u.com" target="_blank" rel="noopener noreferrer">
              viaa4u.com
            </a>
            , or reach out at{' '}
            <a href="tel:+13143334910">(314) 333-4910</a> or{' '}
            <a href="mailto:info@viaa4u.com">info@viaa4u.com</a>.
          </p>
          <p>
            We are excited about the opportunities this partnership presents and are
            available to address any inquiries or feedback you may have.
          </p>
          <NavLink to={'/who-we-trust'} id={styles.homeBtn}>
            Back to Who We Trust
          </NavLink>
        </div>
      </ContentContainer>
    </div>
  );
};

export default PFSVIAA;